<template>
  <Index/>
</template>

<script>
  import Index from './ticket_description/Index.vue'

  export default {
    components: { Index },
    name: 'TicketDescription',
  }
</script>

<style scoped>
</style>